import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DateAdapter, MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Howtoplaymaster, UserMaster } from '../AllModels';
import { addUserMasterURL, updateLineMasterURL, getByIdUserMasterURL, getAllUserMasterURL, checkMobileNumberURL, saveHowToPlayURL, updateHowToPlayURL, getAllHowToPlayURL, getByIdHowToPlayURl } from '../AllURL';
import { HttpmethodsService } from '../shared/service/httpmethods.service';

@Component({
  selector: 'app-howtoplaymaster',
  templateUrl: './howtoplaymaster.component.html',
  styleUrls: ['./howtoplaymaster.component.css']
})
export class HowtoplaymasterComponent implements OnInit {

  howtoplaymasterForm: FormGroup;
  HowtoplaymasterModel = new Howtoplaymaster();
  isEdit: boolean = true;
  hide = true;
  mobileMsg: string;
  mobFlag: boolean = false;
  textColorMobile: string;

  constructor(private formBuilder: FormBuilder, public toastr: ToastrManager, private httpService: HttpmethodsService, private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('en-GB');
  }

  displayedColumns: string[] = ['Sr.No.', 'Video Name', 'videolink', 'Status', 'Action'];
  dataSource = new MatTableDataSource<UserMaster>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('epltable', { static: false }) epltable: ElementRef;

  ngOnInit() {
    this.howtoplaymasterForm = this.formBuilder.group({
      videoname: new FormControl('', [Validators.required,]),
      videoLink: new FormControl('', [Validators.required]),
      status: new FormControl('', [Validators.required]),
    })
    this.getAllUser();
    this.hide = true;
  }


  SaveUser() {
    if (this.isEdit) {
        this.httpService.postRequest(saveHowToPlayURL, this.HowtoplaymasterModel).subscribe((data: any) => {
          if (data) {
            this.isEdit = true;
            this.toastr.successToastr('Save Successfully...!', 'Success!', { timeout: 500 });
            this.getAllUser();
            this.howtoplaymasterForm.reset();
            this.mobileMsg=" ";
            
          }
          else {
            this.toastr.errorToastr("Something went Wrong.", "Error");
          }
        })
    }
    else {
        this.httpService.putRequest(updateHowToPlayURL, this.HowtoplaymasterModel).subscribe((data: any) => {
          if (data) {
            this.isEdit = true;
            this.toastr.successToastr('Update Successfully...!', 'Success!', { timeout: 500 });
            this.getAllUser();
            this.howtoplaymasterForm.reset();
            this.mobileMsg=" ";
          }
          else {
            this.toastr.errorToastr("Something went Wrong.", "Error");
          }
        })
   
    }  
  }

  getUserById(howToPlayMasterId) {
    this.httpService.getRequest(getByIdHowToPlayURl + "/" + howToPlayMasterId).subscribe((data: any) => {
      this.HowtoplaymasterModel = data;
      this.isEdit = false;
      const element = document.querySelector('#scrollId');
      element.scrollIntoView();
    })
  }

  getAllUser() {
    this.httpService.getRequest(getAllHowToPlayURL).subscribe((data: any) => {
      if (data) {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
      }
      else {
        this.toastr.errorToastr("No Records Found.", "Error");
      }
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


}
